import PopupDom from "./Popup";
import MaskDom from "./Mask";
import { wrapFC } from "./Wrap";
export { PopupDom };
export const Mask = wrapFC(MaskDom);
const Popup = wrapFC(PopupDom);
export default Popup;
export { PopupLayout } from "./components";